module.exports = "https://cdn.realtymogul.com/static/media/icon_closeX_blk.685aa7b6.svg";